import { Card, Link as ComponentLibraryLink } from '@ps/sports-ui-component-library';
import { Link, Translation } from '@ps/web-shared-components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { ExpandablePanel, Icon, Title } from '@swf/sports/components';
import GroupedTemplatePanels from '@swf/sports/components/GroupedTemplatePanels/GroupedTemplatePanels';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';
import useLiveDataPolling from '@swf/sports/hooks/useLiveDataPolling/useLiveDataPolling';
import { getEventTypesInPlayEventIdsFromMarketViewsMap } from '@swf/sports/utils/getEventTypesInPlayEventIdsMap';
import { notEmpty } from '@swf/sports/utils/notEmpty';

import { useSportsLandingPageWidget } from '../../model';

import { TXTWCL_All_In_Play, TXTWCL_In_Play } from './InPlayEvents.messages.json';

const InPlayEvents: React.FC = () => {
  const { widgetSelect } = useSportsLandingPageWidget();
  const inPlayEvents = useSelector(widgetSelect.inPlayEvents);
  const { eventTypeId, eventTypeSlug } = useSelector(select.sports.getUrlParams);
  const markets = useSelector(widgetSelect.markets);

  const eventTypesEventIdsMap = useMemo(
    () => getEventTypesInPlayEventIdsFromMarketViewsMap(Object.values(markets).filter(notEmpty)),
    [markets]
  );

  useLiveDataPolling({ eventTypesEventIdsMap });

  return (
    <ExpandablePanel
      title={
        <Title isNested>
          <Translation {...TXTWCL_In_Play} />
        </Title>
      }
      isNested
    >
      <GroupedTemplatePanels groupedOn="COMPETITION" groups={inPlayEvents[0]} isNested />
      <Card padded>
        <ComponentLibraryLink variant="secondary" asChild isButtonLink>
          <Link alias="sportsInPlaySport" values={{ eventTypeId, eventTypeSlug }}>
            <Translation {...TXTWCL_All_In_Play} />
            <Icon name="chevron-small-right" size="xl" />
          </Link>
        </ComponentLibraryLink>
      </Card>
    </ExpandablePanel>
  );
};

export default () => (
  <SportsComponent name="Sports In Play Events Component">
    <InPlayEvents />
  </SportsComponent>
);
